import { memo, useCallback, useState, useEffect, useMemo } from 'react';
import { BzChip, BzToolTip } from "../../components";
import { Col, Row } from 'react-bootstrap';
import { WATCHLIST_GRID_INDEX, TL_INDEX, SCRIP_INSTRUMENTS } from '../../utils/global_variables';
import { useDispatch, useSelector } from 'react-redux';
import { WATCHLIST_GRID_REF, convertDateToSeconds, convertScripResponseWatchlistGrid, convertTouclineIndexToWatchlistGridIndex, getApiExchangeNameFromMktSegId, getChangeInRs, getScripDisplayDescription, isUserIsAGuest, openOrderEntryModal, openOverviewModal, removeExpiriedScrip } from '../../utils/global_functions';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { useKeyWithCtrl, useSingleKey, useWFHMessages } from '../../hooks';
import { SIDE_TRAY_EXPAND_PERCENTAGE, FACILITY_NUM } from '../../utils/global_variables';
import DontMissChip from '../DontMiss/DontMissChip';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { updateIsBuyOrSell } from '../../redux/actions/orders';
import { toastConfig } from '../../redux/actions/toast';
import { _getScripsInfo, _resetGridFeatures } from '../../controllers/watchlist';
import { setArrScripToBeAdded } from '../../redux/actions/globalSearch';
import { setIsIndicesOverview } from '../../redux/actions/indices';

const WatchListScripCard = ({ isDashboardQuickWatchScrolling, setIsSideBar, setIsGlobalSearch, arrRowData, className, isAddtoWatchlist = false, children, handleSelectSpreadOrderModel, setIsExpanded, isExpiry = false, strFutureExpiry, pageCalled, mouseClickX, mouseClickY, setShowScripCard, ...props }) => {
    if (arrRowData?.length > 0) {
        arrRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = parseFloat(arrRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]).toFixed(arrRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
    } else { }
    const dispatch = useDispatch();
    const [holdingInfo, setHoldingInfo] = useState([]);
    const holdingsScrips = useSelector(state => state.holdings.holdingsScrips);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const modals = useSelector(state => state?.modals?.modals);
    const modalData = useSelector(state => state?.modals?.modalData);

    useKeyWithCtrl('delete', (e) => {
        e.preventDefault();
        setShowScripCard(false)
    });

    useSingleKey('delete', (e) => {
        if (!modals['ORDER_ENTRY_MODAL']) {
            e.preventDefault();
            setShowScripCard(false)
        }
    });

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (['F1', 'F2', 'F3', 'F5', 'F6', 'n', 'v', 'V', 'Enter'].includes(event.key)) {
                setShowScripCard(false)
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {

            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (isDashboardQuickWatchScrolling !== undefined && isDashboardQuickWatchScrolling) {
            setShowScripCard(false)
        }
    }, [isDashboardQuickWatchScrolling]);

    const handleSetAlert = (scrip) => {
        if (setIsExpanded && setIsSideBar) {
            setIsSideBar(false);
            setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); //BT-112513 Closing side menu on right click of grid : ManasaB : 11/07/2023 Functionality modified by Hiral Mam side menu should close on click of options in the pop over grid

        } else { }
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (!isNotExpired) {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            return;
        }
        setTimeout(() => {
            dispatch(toastConfig({}));
        }, 50);
        _resetGridFeatures(WATCHLIST_GRID_REF);
        setShowScripCard(false)
        dispatch(handleModalData({
            AlertData: {
                symbol: scrip[WATCHLIST_GRID_INDEX.SYMBOL],
                exchange: scrip[WATCHLIST_GRID_INDEX.EXCHANGE],
                series: scrip[WATCHLIST_GRID_INDEX.INSTRUMENT]?.substring(0, 2),
                description: isExpiry ? strFutureExpiry : getScripDisplayDescription(scrip),
                token: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                mktId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                mappedMktId: scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                decimalLocator: scrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                decimalLocator_length: scrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                exchange_segement: getApiExchangeNameFromMktSegId(scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                expiryDate: scrip[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                instrument: scrip[WATCHLIST_GRID_INDEX.INSTRUMENT],
            },
            isShowAlerts: true
        }));

        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };

    const handlePlaceOrder = async (nIsBuyOrSell = 0, arrRowData) => {
        await openOrderEntryModal(arrScripData, arrRowData, objLoginSession, null, null, nIsBuyOrSell);
    };

    const onBuySellClick = async (strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (!isNotExpired) {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            return;
        }
        if (pageCalled) {
            if (arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID] && arrRowData[WATCHLIST_GRID_INDEX.TOKEN]) {
            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Cannot open order entry of following Scrip', }));
                return;
            }
        }
        const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: arrRowData[WATCHLIST_GRID_INDEX.TOKEN] }]);
        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
        const scripData = convertScripResponseWatchlistGrid(scripDataObj);
        setShowScripCard(false)
        if (!isUserIsAGuest('buy_sell')) {
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
            dispatch(toastConfig({}));
            if (setIsExpanded && setIsSideBar) {
                setIsSideBar(false);
                setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); //BT-112513 Closing side menu on right click of grid : ManasaB : 11/07/2023 Functionality modified by Hiral Mam side menu should close on click of options in the pop over grid
            } else { }
            _resetGridFeatures(WATCHLIST_GRID_REF);
            const rowData = pageCalled ? scripData[0] : arrRowData;
            if (pageCalled) {
                if (scripData[0][WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                    if (objCFT?.MULTILEG) {
                        handleSelectSpreadOrderModel(scripData[0], strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
                        handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData);
                    }
                    else {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                    }
                } else { handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData); }
            } else {
                if (arrRowData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                    if (objCFT?.MULTILEG) {
                        handleSelectSpreadOrderModel(arrRowData, strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
                        handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData);
                    }
                    else {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                    }
                } else { handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData); }
            }
        } else { }


    };

    const handleOverview = useCallback(() => {
        setShowScripCard(false)
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (isNotExpired) {
            openOverviewModal(pageCalled, arrRowData, setIsExpanded, setIsSideBar, dispatch, modalData);
            dispatch(setIsIndicesOverview(false));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
        }
    }, [arrRowData, setIsExpanded, setIsSideBar, dispatch]);

    const handleChart = () => {
        setShowScripCard(false)
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (isNotExpired) {
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
            dispatch(setScripOverviewData(arrRowData));
            dispatch(handleModalData({ tab: 'analysis' }));
            dispatch(setIsIndicesOverview(false));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
        }
    };


    const [arrScripData, setArrScripData] = useState([]);

    const netChangeFormater = useCallback((detail) => {
        if (detail[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] > 0) {
            let netChangeValue = (detail[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);//By HiralK : 06-09-2023 : For Price optimization
            return netChangeValue;
        }
        return (detail[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);	    //By HiralK : 06-09-2023 : For Price optimization

    }, [arrRowData]);

    const handleArrGridRowData = (segmentId, token, e) => {
        const detail = [...e.detail];
        if (segmentId === detail[TL_INDEX.SEGMENT_ID] && token === detail[TL_INDEX.TOKEN]) {
            let arrConvertedData = convertTouclineIndexToWatchlistGridIndex(detail);
            setArrScripData([...arrConvertedData]);
        }
    };

    useWFHMessages('touchline', (e) => {
        handleArrGridRowData(arrRowData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], arrRowData?.[WATCHLIST_GRID_INDEX.TOKEN], e);
    });

    useEffect(() => {
        if (arrRowData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            const arrLastTickScripData = objLastTickData[arrRowData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
            if (arrLastTickScripData?.length > 0) {
                let arrConvertedData = convertTouclineIndexToWatchlistGridIndex(arrLastTickScripData);
                setArrScripData([...arrConvertedData]);
            } else {
                setArrScripData([...arrRowData]);
            }
        } else { }
    }, [dispatch, arrRowData, netChangeFormater]);

    const WatchlistGridPopoverName = useCallback(() => {
        if (isExpiry) {
            return (<div className='font-regular font-size2 color-subtext'>{strFutureExpiry}</div>);

        } else if ((arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT])) {
            return (<div className='font-regular font-size2 color-subtext'>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]} `}</div>);
        } else if (!arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            !arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]) {
            return (<div className='d-flex align-items-center'><div className='font-regular font-size2 color-subtext'>{arrRowData[WATCHLIST_GRID_INDEX.SERIES]}</div></div>);
        }
        else if (arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) {
            return (
                <div className='font-regular font-size2 color-subtext'>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT].slice(0, 3)} `}</div>
            );
        } else {
            return null;
        }
    }, [arrRowData]);

    const handleAddToWatchlist = () => {
        setShowScripCard(false)
        dispatch(setArrScripToBeAdded([arrRowData]));
        dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }]));
    };

    const getHoldingsData = useMemo(() => {
        if (holdingsScrips?.length && arrRowData?.length) {
            let nIndex = holdingsScrips?.findIndex((eachHolding) => eachHolding?.TOTALFREEQUANTITY !== "0" && eachHolding?.ISIN === arrRowData[WATCHLIST_GRID_INDEX.ISIN_CODE] && arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES);
            return nIndex;
        } else { return -1; }
    }, [holdingsScrips, arrRowData]);

    useEffect(() => {
        if (holdingsScrips?.length && arrScripData?.length) {
            if (holdingsScrips[getHoldingsData]?.nBuyAvgPrice && parseFloat(arrScripData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) !== 0) {
                let arrNetChangePNL = getChangeInRs((arrScripData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] * holdingsScrips[getHoldingsData]['TOTALFREEQUANTITY']).toFixed(2), (parseFloat(holdingsScrips[getHoldingsData]?.nBuyAvgPrice) * parseInt(holdingsScrips[getHoldingsData]?.TOTALFREEQUANTITY)).toFixed(2), 2, false, 'uptrend');
                setHoldingInfo(arrNetChangePNL);
            }
        } else {
            setHoldingInfo([]);
        }
    }, [arrScripData]);

    return (
                arrRowData?.length > 0 &&
                <div className='heatmap-scripdetails-popover' style={{left: mouseClickX, top: mouseClickY}}>
                        <div className='p-2'>
                            <Row className='g-0'>
                                <Col className='justify-content-start align-items-start'>
                                    <Row className='g-0 align-items-start'>
                                        <Col md={7} className='d-flex flex-row align-items-center'>
                                            <div className='font-medium font-size4 color-text float-start me-2'>{arrRowData[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                            <div className='chips-wrap'>
                                                <BzChip className='exchange-chip'>{arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                            </div>
                                        </Col>
                                        <Col md={5} className='d-flex justify-content-end'>
                                            {
                                                arrScripData?.length > 0
                                                    ?
                                                    <div className='font-medium font-size4 color-text'>{arrScripData?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                                                    :
                                                    <div className='font-medium font-size4 color-text'>{(0).toFixed(2)}</div>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className='g-0 align-items-start'>
                                        <Col md={7} className='justify-content-start'>
                                            <WatchlistGridPopoverName />
                                        </Col>
                                        <Col md={5} className='d-flex justify-content-end'>
                                            {
                                                arrScripData?.length > 0
                                                    ?
                                                    <>
                                                        <div className={`font-medium font-size2 color-text float-start ${parseFloat(arrScripData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrScripData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>
                                                            {parseFloat(arrScripData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(2)}</div>
                                                        <div className={`font-medium font-size2 color-text ms-1 ${parseFloat(arrScripData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrScripData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>({parseFloat(arrScripData?.[WATCHLIST_GRID_INDEX?.NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(2)}%)</div>
                                                    </>
                                                    :
                                                    <div className={`font-medium font-size2 color-text`}>{(0).toFixed(2)} {(0).toFixed(2)}%</div>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div className='bdr-top'>
                            <Row className='g-0 p-2'>
                                <Col className='d-flex justify-content-around'>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Overview'}>
                                        <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleOverview}>
                                            <div class="icon-20 icon-eye icon-primary"></div>
                                        </button>
                                    </BzToolTip>

                                    <BzToolTip placement={'bottom'} TooltipMsg={'Chart'}>
                                        <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleChart}>
                                            <div class="icon-20 icon-graph icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                    {
                                        objCFT.ALERT === FACILITY_NUM.ON && (
                                            <BzToolTip placement={'bottom'} TooltipMsg={'Alert'}>
                                                <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleSetAlert?.bind(this, arrRowData)}>
                                                    <div class="icon-20 icon-alert icon-primary"></div>
                                                </button>
                                            </BzToolTip>
                                        )
                                    }
                                    {isAddtoWatchlist &&
                                        <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                            <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleAddToWatchlist}>
                                                <div class="icon-20 icon-add-circle icon-primary"></div>
                                            </button>
                                        </BzToolTip>
                                    }
                                    <button onClick={() => onBuySellClick('BUY')} className='btn btn-sm btn-positive text-uppercase me-2'>&nbsp;B&nbsp;</button>
                                    <button onClick={() => onBuySellClick('SELL')} className='btn btn-sm btn-negative text-uppercase'>&nbsp;S&nbsp;</button>
                                </Col>
                            </Row>
                        </div>
                        <div className='bdr-top'>
                            <div className='px-2 pb-2'>
                                {getHoldingsData >= 0 &&
                                    <Row className='g-0 py-2 cursor-pointer align-items-center'>
                                        <Col className='d-flex'>
                                            <div className='icon-16 icon-portfolio icon-dark'></div>
                                            <div className='font-regular font-size2 color-text ms-2'>{holdingsScrips[getHoldingsData].TOTALFREEQUANTITY}</div>
                                            {(holdingInfo?.length) ?
                                                <div className='d-flex align-items-center ms-2'>
                                                    <div className={`font-regular font-size2 color-text ${holdingInfo[2]}`}>&#8377;{`${Number(holdingInfo[0]).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</div>
                                                    <div className={`font-regular font-size2 color-text ms-1 ${holdingInfo[2]}`}>({holdingInfo[1]})</div>
                                                </div>
                                                : null
                                            }
                                        </Col>
                                    </Row>
                                }
                                {
                                    arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 &&
                                    <Row className='g-0 py-2 align-items-center'>
                                        <Col className='d-flex'>
                                            <div className='icon-16 icon-dontmiss icon-yellow'></div>
                                            <div className='chips-wrap ms-2'>
                                                <DontMissChip value={arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]} isShowAllChips />
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </div>
                </div>

    );
};  

export default memo(WatchListScripCard);